import React, {useEffect, useState} from "react";
import {RouteComponentProps, useParams} from "react-router";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Button, Card, Col, Form, Input, InputNumber, message, Row, Select, Space, Switch, UploadFile} from "antd";
import Divider from "../../components/Divider";
import {useRequest} from "ahooks";
import * as api from "../../apis/product";
import * as categoryApi from "../../apis/productCategory"
import {useForm} from "antd/lib/form/Form";
import DatePicker from "../../components/DatePicker";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import DictSelect from "../../components/DictSelect";
import CategoryCascader from "../../components/CategoryCascader";
import {useHistory} from "react-router-dom";
import GiveawayRulesModal from "../../components/GiveawayRulesModal";

import styles from "./index.module.css";
import Upload from "../../components/Upload";
import {PlusOutlined} from "@ant-design/icons";
import {ValidateStatus} from "antd/es/form/FormItem";
import * as minIoUtil from "../../utils/minio"
import * as utils from "../../utils/utils";
import * as qualificationApi from "../../apis/qualification";
import withAuth from "../../utils/withAuth";


type RouteParams = {
    id: string
}

const EditButton = withAuth('edit', Button);
const StatusButton = withAuth('updateStatus', Button);
const UpdateCodeButton = withAuth('code', Button);

function ProductDetail(props: RouteComponentProps<RouteParams>) {
    const history = useHistory();
    const params = useParams<RouteParams>();
    const [form] = useForm();
    const isCreateMode = params.id === 'add';
    const [enableModify, setEnableModify] = useState<boolean>(isCreateMode ? true : false);
    const dict: any = useSelector<RootState>(root => root.dict);
    const [categories, setCategories] = useState<Array<any>>([]);
    const [giftModalVisible, setGiftModalVisible] = useState(false);
    const [productStatus, setProductStatus] = useState<boolean>(false);
    const [qualifications, setQualifications] = useState([]);
    const {loading: loadingProduct, run: getProduct} = useRequest(api.getProduct, {
        manual: true,
        onSuccess(res) {
            const result = res.data.data;
            form.setFieldsValue(result);
            setProductStatus(!!result.status);
            runGetQualifications(result.id);
        }
    });

    const {
        loading: loadingGetQualifications,
        run: runGetQualifications
    } = useRequest(qualificationApi.getQualificationsByProduct, {
        manual: true,
        onSuccess(res) {
            const result = res.data.data || [];
            setQualifications(result);
        }
    })


    const doSubmit = async (value: any) => {
        let id = value.id;
        const {/*qualityReports=[], */image, ...productValue} = value;

        if (image?.originFileObj) {
            if (!isCreateMode) {
                const key = utils.generateFileName(`product/${id}/image`, image.name);
                productValue.image = await minIoUtil.upload(image.originFileObj, key);
                await api.modifyProduct(productValue);
            } else {
                const response = await api.modifyProduct(productValue);
                id = response.data.data;
                const key = utils.generateFileName(`product/${id}/image`, image.name);
                productValue.image = await minIoUtil.upload(image.originFileObj, key)
                await api.updateImage(id, productValue.image)
            }
        } else {
            const response = await api.modifyProduct({...productValue, image})
            id = isCreateMode ? response.data.data : id;
        }
        // for (const item of qualityReports) {
        //     if(item.file?.originFileObj){
        //         const key = utils.generateFileName(`product/${id}/qualityReports`, item.file.name);
        //         item.file = await minIoUtil.upload(item.file.originFileObj, key);
        //     }
        // }
        // await api.updateQualityReports(id, qualityReports);
        if (isCreateMode) {
            setEnableModify(false);
            history.replace(`/product/product/${id}`);
        } else {
            setEnableModify(false);
            getProduct(parseInt(id));
        }

    }


    const {loading: loadingProductModify, run: submitProduct} = useRequest(doSubmit, {
        manual: true,
        onSuccess(res) {

        }
    });
    const {loading: loadingUpdateStatus, run: updateStatus} = useRequest(api.updateStatus, {
        manual: true,
        onSuccess() {
            getProduct(parseInt(params.id));
        }
    })
    useEffect(() => {
        if (!isCreateMode) {
            getProduct(parseInt(params.id));
        }
    }, [isCreateMode]);

    const {loading: loadingCategories, run: getCategories} = useRequest(categoryApi.getCategoriesDict, {
        defaultParams: [],
        onSuccess(res) {
            setCategories(res.data.data);
        }
    });

    const {loading: loadingUpdateCode, run: runUpdateCode} = useRequest(api.updateCode, {
        manual: true,
        onSuccess(res) {
            message.success('修改成功');
            getProduct(parseInt(params.id));
        }
    })

    const toolbar = isCreateMode ? null : (
        <Space style={{justifyContent: "flex-end", width: "100%"}}>
            <Divider>
                <UpdateCodeButton type={"link"} loading={loadingUpdateCode}
                                  onClick={() => handleUpdateCode()}>修改编号</UpdateCodeButton>
                <EditButton type={'link'} loading={loadingProductModify}
                            onClick={() => setEnableModify(true)}>修改</EditButton>
                <StatusButton type={'link'} loading={loadingUpdateStatus}
                              onClick={() => updateStatus(parseInt(params.id), !productStatus)}>{productStatus ? '停用' : '启用'}</StatusButton>
                <Button type={'link'} onClick={() => history.goBack()}>返回</Button>
            </Divider>
        </Space>
    );

    const handleSubmit = () => {
        form.validateFields().then(value => {
            submitProduct(value);
        }).catch((reason => {
            message.error(reason);
        }))
    };

    const handleUpdateCode = () => {
        const code = window.prompt('请输入新编号');
        if (!!code) {
            runUpdateCode(params.id, code);
        }
    }


    const handleCancel = () => {
        if (isCreateMode) {
            history.goBack();
        } else {
            setEnableModify(false);
            getProduct(parseInt(params.id));

        }
    }

    const handleGiftModalShow = () => {
        setGiftModalVisible(true);
    }

    const productQualityReportsRender = () => {
        if (isCreateMode || enableModify) {
            return;
        }
        return qualifications?.length ? (
            <>
                <h3 className={styles.SectionTitle}>质检报告</h3>
                <table className={styles.QualificationsContainer}>
                    {qualifications.map((q: any) => (<tr>
                        <td><a onClick={() => window.open(minIoUtil.getUrl(q.path.replace('#', '%23')))}>{q.batchNo}</a></td>
                    </tr>))}
                </table>
            </>
        ) : null;
    }


    return (
        <PageHeaderLayout withFooterBar={enableModify} onCancel={handleCancel} onOk={handleSubmit}
                          btnLoading={loadingProductModify}>
            <Card title={toolbar}>
                <Form form={form} labelCol={{span: 4}} disabled={!enableModify}>
                    <Form.Item name={'id'} noStyle/>
                    <h3 className={styles.SectionTitle}>基本信息</h3>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name={'code'} label={'商品编号'} rules={[{required: true}]}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'name'} label={'商品名称'} rules={[{required: true}]}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'specification'} label={'规格'} rules={[{required: true}]}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'unit'} label={'计量单位'} rules={[{required: true}]}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'registeredName'} label={'注册名称'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'abbreviation'} label={'英文缩写'} rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'licenseCode'} label={'生产许可证号'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'standardCode'} label={'产品标准编号'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'certificateCode'} label={'注册证编码'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'certificateValidity'} label={'注册证有效期'}>
                                <DatePicker/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'manufacturer'} label={'生产厂家'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'aptitude'} label={'资质'} rules={[{required: true}]}>
                                <DictSelect dict={'ProductAptitude'} disabled={!isCreateMode} appendNull={false}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'categoryId'} label={'产品线'} rules={[{required: true}]}>
                                <CategoryCascader options={categories}
                                                  disabled={!isCreateMode}
                                                  changeOnSelect
                                                  fieldNames={{label: "name", children: "children", value: "id"}}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'rate'} label={'税率'} rules={[{required: true}]}>
                                <Input suffix={"%"} disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'capacity'} label={'容量'} initialValue={0}>
                                <InputNumber addonAfter={"ml"}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'quote'} label={'标准报价'}>
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'inventoryUnfulfillable'} label={'不可售库存'}>
                                <InputNumber step={1}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'inventoryTight'} label={'库存紧张限定'}
                                       tooltip={'库存紧张时，下单数量不能超过库存紧张限定数量'} initialValue={0}>
                                <InputNumber/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'unitWeight'} label={'单位重量'}>
                                <InputNumber addonAfter={"g"}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'attribute'} label={'商品性质'} rules={[{required: true}]}>
                                <DictSelect dict={'ProductAttribute'}/>
                            </Form.Item>
                        </Col>
                        {/*<Col span={12}>*/}
                        {/*    <Form.Item name={'synYunyigou'} label={'同步云医购'} initialValue={false}>*/}
                        {/*        <Switch disabled={!isCreateMode}/>*/}
                        {/*    </Form.Item>*/}
                        {/*</Col>*/}
                        <Col span={12}>
                            <Form.Item name={'nature'} label={'商品属性'} rules={[{required: true}]}>
                                <DictSelect dict={'ProductNature'}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'赠品类型'}>
                                <Form.List name={'giveaways'}>
                                    {(fields) => {
                                        return (
                                            <Space>
                                                {form.getFieldValue('giveaways')?.length ? '有赠品' : '无赠品'}
                                                <a onClick={handleGiftModalShow}>赠品设置</a>
                                            </Space>
                                        )
                                    }}
                                </Form.List>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'方法'} name={'method'}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'适用机型'} name={'useIn'}>
                                <Input disabled={!isCreateMode}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name={'status'} label={'状态'} valuePropName={'checked'} initialValue={false}>
                                <Switch checkedChildren={'启用'} unCheckedChildren={'停用'}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <h3 className={styles.SectionTitle}>商品图片<h6 className={styles.SectionSubTitle}>（图片最大1M）</h6>
                    </h3>
                    <Row>
                        <Col span={1}/>
                        <Form.Item name={'image'} rules={[{validator: Upload.validator({limit: 1024 * 1024})}]}>
                            <Upload listType={"picture-card"} maxCount={1} accept={'image/*'}>
                                <div className={styles.UploadInput}>
                                    <PlusOutlined/>
                                    <label>上传图片</label>
                                </div>
                            </Upload>
                        </Form.Item>
                    </Row>
                </Form>
                {
                    productQualityReportsRender()
                }

                <GiveawayRulesModal open={giftModalVisible}
                                    form={form}
                                    onOk={() => setGiftModalVisible(false)}
                                    onCancel={() => setGiftModalVisible(false)}
                                    enableModify={enableModify}/>
            </Card>
        </PageHeaderLayout>
    )
}

export default ProductDetail;
